import { render, staticRenderFns } from "./BirthdatePicker.vue?vue&type=template&id=c2c2d6dc"
import script from "./BirthdatePicker.vue?vue&type=script&lang=js"
export * from "./BirthdatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports